module.exports = "/images/jcb.png";